import { render, staticRenderFns } from "./whatsApp.vue?vue&type=template&id=0935e2a0"
import script from "./whatsApp.vue?vue&type=script&lang=js"
export * from "./whatsApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports